module.exports = __webpack_public_path__ + "static/media/brunch2.7e874938.png";